import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'
import { SessionStore } from '../stores'
import { getTenant } from './get-tenant'
import { SessionManager } from '../components/session-manager'

export function withAuth (AuthComponent) {
  @inject('sessionStore')
  @observer
  class Authenticated extends Component {
    constructor (props) {
      super(props)
      this.state = {
        ready: false
      }
    }

    checkLogin () {
      if (!this.props.sessionStore.isLoggedIn) {
        this.props.router.push('/login')
      } else {
        this.setState({ ready: true })
      }
    }

    adminLogin () {
      if (!this.props.sessionStore.isAdminLoggedIn) {
        this.props.router.push('/login')
      } else {
        this.setState({ ready: true })
      }
    }

    componentDidMount () {
      if (this.props.sessionStore.hasTenant) {
        this.checkLogin()
      } else {
        const tenant = getTenant()
        if (tenant === 'systemadmin') {
          this.props.sessionStore.setSysAdmin(tenant)
          this.adminLogin()
        } else {
          this.props.sessionStore.tenantExists(tenant)
            .then((res) => {
              if (!res.data.exists) {
                this.props.router.push('/register')
                return
              }
              this.props.sessionStore.setTenant(tenant)
              this.checkLogin()
            })
            .catch((err) => {
              this.props.sessionStore.setLastError(err)
              this.props.router.push('/error')
            })
        }
      }
    }

    render () {
      if (this.state.ready) {
        return (
          <React.Fragment>
            <SessionManager {...this.props} />
            <AuthComponent {...this.props} />
          </React.Fragment>
        )
      } else {
        return <div>&nbsp;</div>
      }
    }
  }

  Authenticated.propTypes = {
    router: PropTypes.object,
    sessionStore: PropTypes.instanceOf(SessionStore)
  }

  return Authenticated
}
